import React, {
    useCallback,
    useState,
} from 'react'
import { SerializedStyles } from '@emotion/react'

import { useTranslation } from 'shared/hooks/useSafeTranslation'

import useStyle from 'shared/hooks/useStyle'
import StepPageLayout from 'shared/StepPageLayout'
import EmptyStepContent from 'shared/EmptyStepContent'
import styles from './PictureLayout.style'

type Props = {
    image?: string
    title: string
    children?: React.ReactElement
    noStepUI?: boolean
    isRequired?: boolean
    isAnswered?: boolean
    isNested?: boolean
    isSummaryView?: boolean
    customClasses?: {
        actions?: SerializedStyles,
    },
}

const PictureLayout = ({
    image,
    title,
    children = null,
    noStepUI = false,
    isRequired = false,
    isAnswered = false,
    isNested = false,
    isSummaryView = false,
    customClasses,
}: Readonly<Props>) => {
    const [
        isLanscapePicture,
        setIsLanscapePicture,
    ] = useState(true)
    const classes = useStyle(styles)
    const { t } = useTranslation()
    const imageLoaded = useCallback((args) => {
        if (args.target.naturalHeight > args.target.naturalWidth) {
            setIsLanscapePicture(false)
        }
    }, [])

    const imageLayout = (
        <div css={classes.form}>
            <div css={classes.pictureContainer}>
                <div css={classes.pictureContainerLayout}>
                    { image && (
                        <img
                            css={isLanscapePicture ? classes.picture : classes.pictureVr}
                            src={image}
                            alt="test"
                            onLoad={imageLoaded}
                        />
                    )}
                    { !image && (<EmptyStepContent title={t('NO_PICTURE')} />)}
                </div>
            </div>
            <div css={[
                classes.actions,
                customClasses?.actions,
            ]}
            >
                { children}
            </div>
        </div>
    )

    if (noStepUI) {
        return imageLayout
    }

    return (
        <StepPageLayout
            title={title}
            isRequired={isRequired}
            isAnswered={isAnswered}
            isNested={isNested}
            isSummaryView={isSummaryView}
        >
            {imageLayout}
        </StepPageLayout>
    )
}

export default PictureLayout
